export const skillToSlotLevel = {
  '無し':               0,

  '龍耐性':             1,
  '氷耐性':             1,
  '雷耐性':             1,
  '水耐性':             1,
  '火耐性':             1,
  '毒耐性':             1,
  '麻痺耐性':           1,
  '睡眠耐性':           1,
  '爆破やられ耐性':     1,
  '植生学':             1,
  '地質学':             1,
  '飛び込み':           1,
  '陽動':               1,
  '泥雪耐性':           1,
  '満足感':             1,
  '腹減り耐性':         1,
  '剥ぎ取り鉄人':       1,
  '防御':               1,
  '龍属性攻撃強化':     1,
  '氷属性攻撃強化':     1,
  '雷属性攻撃強化':     1,
  '水属性攻撃強化':     1,
  '火属性攻撃強化':     1,
  'ボマー':             1,
  '滑走強化':           1,
  '毒属性強化':         1,
  'スタミナ奪取':       1,
  '笛吹き名人':         1,
  '回復速度':           1,
  '砥石使用高速化':     1,
  '風圧耐性':           1,
  'ひるみ軽減':         1,
  'ブレ抑制':           1,
  '気絶耐性':           1,
  '装填速度':           1,
  '反動軽減':           1,

  '不屈':               2,
  '乗り名人':           2,
  '体術':               2,
  '体力回復量UP':       2,
  'アイテム使用強化':   2,
  '翔蟲使い':           2,
  '壁面移動':           2,
  '精霊の加護':         2,
  '早食い':             2,
  '属性やられ耐性':     2,
  '破壊王':             2,
  '広域化':             2,
  'KO術':               2,
  '納刀術':             2,
  '回避性能':           2,
  '回避距離UP':         2,
  '抜刀術【力】':       2,
  '泡沫の舞':           2,
  '逆襲':               2,
  '耐震':               2,
  '鈍器使い':           2,
  '高速変形':           2,
  '見切り':             2,
  '攻撃':               2,
  '渾身':               2,
  '強化持続':           2,
  'スタミナ急速回復':   2,
  'ガード性能':         2,
  'ガード強化':         2,
  '砲弾装填':           2,
  '特殊射撃強化':       2,
  '火事場力':           2,
  '心眼':               2,
  '集中':               2,
  'ランナー':           2,
  '砲術':               2,
  '会心撃【属性】':     2,
  '弾導強化':           2,
  '超会心':             2,
  '弱点特効':           2,
  '挑戦者':             2,
  'フルチャージ':       2,
  '逆恨み':             2,
  '死中に活':           2,
  '力の解放':           2,
  '麻痺属性強化':       2,
  '睡眠属性強化':       2,
  '爆破属性強化':       2,
  '剛刃研磨':           2,
  '業物':               2,
  '弾丸節約':           2,
  '達人芸':             2,

  '耳栓':               3,
  '抜刀術【技】':       3,
  'キノコ大好き':       3,
  '攻めの守勢':         3,
  '装填拡張':           3,
  '通常弾・連射矢強化': 3,
  '貫通弾・貫通矢強化': 3,
  '散弾・拡散矢強化':   3,
  '速射強化':           3,
  'ジャンプ鉄人':       3,
  '鬼火纏':             3,
  '幸運':               3,
  '匠':                 3,
}
